import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import Loader from "./Loader";

export default function ProtectedRoute({ children }) {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return <Loader text="Verifying Session" />;
  }

  if (!isAuthenticated) {
    const fullTarget = location.pathname + (location.search || "");
    try {
      sessionStorage.setItem("sync_redirect", fullTarget);
    } catch (e) {}
    return (
      <Navigate
        to={`/login?redirect=${encodeURIComponent(fullTarget)}`}
        state={{ from: location }}
        replace
      />
    );
  }

  return children;
}
